import Vue from 'vue';
import numeral from 'numeral';
import moment from 'moment-mini';
import JSZip from 'jszip';
import saveAs from 'jszip/vendor/FileSaver.js';
import store from '../state/store';

const globalMethods = Vue.mixin({
  methods: {
    checkAkses(groupName, modulName, accessName) {
      const data_user = store.state;

      if (data_user && data_user.user && data_user.user.user_permission) {
        let check_permission = data_user.user.user_permission.filter(
          (item) => item.name === modulName && item.modul === groupName
        );

        if (check_permission && check_permission.length) {
          if (check_permission[0][accessName] === 1) {
            return true;
          }
        }
      }

      return false;
    },

    saveZip(filename, urls) {
      if (!urls) return;

      const zip = new JSZip();
      const folder = zip.folder('files'); // folder name where all files will be placed in

      urls.forEach((url) => {
        const blobPromise = fetch(url).then((r) => {
          if (r.status === 200) return r.blob();
          return Promise.reject(new Error(r.statusText));
        });
        const name = url.substring(url.lastIndexOf('/') + 1);
        folder.file(name, blobPromise);
      });

      zip
        .generateAsync({ type: 'blob' })
        .then((blob) => saveAs(blob, filename));
    },

    getTotalDebet(data) {
      let total = 0;
      if (!data) {
        return total;
      }

      data.map((i) => {
        total += +i.debet || 0;
      });

      return total;
    },

    getTotalKredit(data) {
      let total = 0;
      if (!data) {
        return total;
      }

      data.map((i) => {
        total += +i.kredit || 0;
      });

      return total;
    },

    currentDate() {
      return moment().format('DD MMM YYYY');
    },

    currentPeriod() {
      return moment().format('MMM YY');
    },

    normalizePeriod(monthYear) {
      let replacePosition = monthYear.split('/');
      return moment(
        replacePosition[1] + '-' + replacePosition[0] + '-01'
      ).format('MMM YY');
    },

    currentDateTime() {
      return moment().format('DD MMM YYYY HH:mm');
    },

    checkDigitContainer(container) {
      if (!container) return false;

      if (container.length > 10 || container.length < 10) {
        return false;
      }

      if (!['U', 'J', 'Z'].includes(container[3])) {
        return false;
      }

      let symbol = {
        A: 10,
        B: 12,
        C: 13,
        D: 14,
        E: 15,
        F: 16,
        G: 17,
        H: 18,
        I: 19,
        J: 20,
        K: 21,
        L: 23,
        M: 24,
        N: 25,
        O: 26,
        P: 27,
        Q: 28,
        R: 29,
        S: 30,
        T: 31,
        U: 32,
        V: 34,
        W: 35,
        X: 36,
        Y: 37,
        Z: 38,
      };

      let rumus = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512];

      let total = 0;
      for (let index = 0; index < container.length; index++) {
        let segment_total = rumus[index] ? rumus[index] : 0;

        if (index < 4) {
          if (symbol[container[index]]) {
            total += +(symbol[container[index]] * segment_total);
          } else {
            return false;
          }
        } else {
          total += +(container[index] * segment_total);
        }
      }

      let total_bagi = parseInt(total / 11);
      let total_kali = total_bagi * 11;
      let selisih = total - total_kali;

      if (selisih < 10) {
        return selisih;
      } else {
        return false;
      }
    },

    formatPeriode(periode) {
      return moment(periode).format('MMM YYYY');
    },

    getMonthByNumber(number = null) {
      let month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agust',
        'Sept',
        'Okt',
        'Nov',
        'Des',
      ];

      if (!number) {
        return '';
      }

      if (month[number - 1]) {
        return month[number - 1];
      } else {
        return '';
      }
    },

    getNumberThisMonth() {
      return moment().format('M');
    },

    getMonthAndYear() {
      return moment().format('MMM YYYY');
    },

    showMessage(message = '', type = 'success') {
      this.$toast(message, {
        type: type,
        timeout: 2500,
      });
    },
    getCurrentDate() {
      return moment().format('DD/MM/YYYY');
    },
    getCurrentDateTrans() {
      return moment().format('YYYY-MM-DD');
    },
    getCurrentDateTransNext(startDate, plusDay) {
      return moment(
        moment(startDate, 'YYYY-MM-DD').add(plusDay, 'days')
      ).format('YYYY-MM-DD');
    },
    getDateUTCFormat(date) {
      return moment(date).toString();
    },
    getCurrentDatePlusDay(startDate, plusDay) {
      return moment(
        moment(startDate, 'DD/MM/YYYY').add(plusDay, 'days')
      ).format('DD/MM/YYYY');
    },
    getCurrentTime() {
      return moment().format('DD/MM/YYYY HH:mm');
    },
    getTimeNow() {
      return moment().format('YYYY-MM-DD HH:mm');
    },
    base64ToBlob(base64Image) {
      const parts = base64Image.split(';base64,');

      // Hold the content type
      const imageType = parts[0].split(':')[1];

      // Decode Base64 string
      const decodedData = window.atob(parts[1]);

      // Create UNIT8ARRAY of size same as row data length
      const uInt8Array = new Uint8Array(decodedData.length);

      // Insert all character code into uInt8Array
      for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
      }

      // Return BLOB image after conversion
      return new Blob([uInt8Array], { type: imageType });
    },
    formatCurrency(value) {
      let formatted = numeral(value).format('0,0');
      return formatted;
    },
    changeFormatDate(date) {
      if (!date || date === '') {
        return '';
      }

      return moment(date).format('YYYY-MM-DD');
    },
    dateFormat(date) {
      if (!date) {
        return '';
      }

      if (date) {
        let result = moment(new Date(date)).format('DD/MM/YYYY');
        if (result === 'Invalid date') {
          result = moment(+new Date(date)).format('DD/MM/YYYY'); // convert to int
          if (result.indexOf('1970') !== -1) {
            result = 'Invalid date';
          }
        }

        if (result === 'Invalid date') {
          result = date;
        }

        return result;
      } else {
        return null;
      }
    },
    normalDate: function(date) {
      if (!date) {
        return '';
      }

      date = date.replace(/\//g, '-');

      if (date) {
        let result = moment(new Date(date)).format('YYYY-MM-DD');
        if (result === 'Invalid date') {
          result = moment(+new Date(date)).format('YYYY-MM-DD'); // convert to int
          if (result.indexOf('1970') !== -1) {
            result = 'Invalid date';
          }
        }

        if (result === 'Invalid date') {
          result = date;
        }

        return result;
      } else {
        return null;
      }
    },
    selisihHari(first_date = null, end_date = null) {
      if (first_date && first_date !== '' && end_date && end_date !== '') {
        let firstDate = moment(first_date);
        let endDate = moment(end_date);
        return endDate.diff(firstDate, 'days');
      }

      return 0;
    },
  },
  filters: {
    formatTime: function(time) {
      if (time) {
        let result = moment(time).format('HH:mm');
        if (result === 'Invalid Time') {
          result = moment(+time).format('HH:mm'); // convert to int
          if (result.indexOf('1970') !== -1) {
            result = 'Invalid Time';
          }
        }

        return result;
      } else {
        return null;
      }
    },

    formatDate: function(date) {
      if (!date) {
        return '';
      }

      if (date) {
        let result = moment(new Date(date)).format('DD MMM YYYY');
        if (result === 'Invalid date') {
          result = moment(+new Date(date)).format('DD MMM YYYY'); // convert to int
          if (result.indexOf('1970') !== -1) {
            result = 'Invalid date';
          }
        }

        if (result === 'Invalid date') {
          result = date;
        }

        return result;
      } else {
        return null;
      }
    },

    formatDateTime: function(date) {
      if (date) {
        let result = moment(date).format('DD/MM/YYYY HH:mm');
        if (result === 'Invalid date') {
          result = moment(+date).format('DD/MM/YYYY HH:mm'); // convert to int
          if (result.indexOf('1970') !== -1) {
            result = 'Invalid date';
          }
        }

        return result;
      } else {
        return null;
      }
    },

    formatMonth: function(date) {
      if (date) {
        let result = moment(date).format('MMM YYYY');
        if (result === 'Invalid date') {
          result = moment(+date).format('MMM YYYY'); // convert to int
          if (result.indexOf('1970') !== -1) {
            result = 'Invalid date';
          }
        }

        return result;
      } else {
        return null;
      }
    },

    formatNumber(value) {
      let formatted = numeral(value).format('0,0.[00]');
      return formatted;
    },

    formatNumberDecimal(value) {
      let formatted = numeral(value).format('0,0.[00]');
      return formatted;
    },

    formatPeriode(periode) {
      return moment(periode).format('MMM YYYY');
    },
  },
});

export default globalMethods;
